<section class="accounts-page">
  <header class="accounts-head">
    <h1>{{ lang.t('accTitle') }}</h1>
    @if (auth.signedIn()) {
      <a routerLink="/portfolio">{{ lang.t('accPort') }}</a>
    } @else {
      <a routerLink="/signup">{{ lang.t('accOpen') }}</a>
    }
  </header>
  <p class="accounts-range">{{ lang.t('accRange') }}</p>
  <div class="account-row">
    @for (tier of tiers(); track tier.tone) {
      <a [class]="'account-card ' + tier.tone" [routerLink]="auth.signedIn() ? '/portfolio' : '/signup'">
        <div class="account-art" aria-hidden="true">
          <span>{{ tier.mark }}</span>
          <b>{{ tier.from }}</b>
        </div>
        <h2>{{ tier.name }}</h2>
        <p>{{ tier.line }}</p>
        <strong>{{ lang.t('accFrom') }} {{ tier.from }}</strong>
      </a>
    }
  </div>
</section>
